export default __webpack_public_path__ + "static/media/3.09f0d091.jpg";